/** VUEX store definition **/

import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import auth from './modules/auth'
import register from './modules/register'
import resetpassword from './modules/resetpassword'
import changepassword from './modules/changepassword'
import Alert from './modules/alert'
import myaccount from './modules/myaccount'
import editprofile from './modules/editprofile'
import dashboard from './modules/dashboard'
import search from './modules/search'
import cart from './modules/cart'
import product from './modules/product'
import order from './modules/order'
import countryListing from './modules/countrylisting'
import services from './modules/services'
import dealerservices from './modules/dealerservices'
import cmspage from './modules/cmspage'
import appointments from './modules/appointments'
import VueFlashMessage from 'vue-flash-message'
import captcha from './modules/captcha'
import offers from './modules/offers'
import banners from './modules/banners'
import page from './modules/page'
import menu from './modules/menu'
import cart_right_sidebar from "./modules/cart_right_sidebar";
import cart_popup_mobile from "./modules/cart_popup_mobile";
import shipping_charge from './modules/shipping_charges'
import product_details from './modules/product_details'
import label from './modules/label'
import search_dealer from "./modules/search_dealer";
import view_image_pd from "./modules/view_image_pd";
import load_eu_label_image from "./modules/load_eu_label_image";
import search_by_service_point from "./modules/search_by_service_point";
import HeaderFooterControl from "./modules/HeaderFooterControl";
import product_new from "./modules/product_new";
import campaign from "./modules/campaign";
import klaviyo_event from "./modules/klaviyo_event";

Vue.use(VueFlashMessage);

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    auth,
    register,
    resetpassword,
    changepassword,
    Alert,
    myaccount,
    editprofile,
    dashboard,
    search,
    cart,
    product,
    order,
    countryListing,
    services,
    dealerservices,
    cmspage,
    appointments,
    captcha,
    offers,
    banners,
    page,
    menu,
    cart_right_sidebar,
    cart_popup_mobile,
    shipping_charge,
    product_details,
    label,
    search_dealer,
    view_image_pd,
    load_eu_label_image,
    search_by_service_point,
    HeaderFooterControl,
    product_new,
    campaign,
    klaviyo_event
  },
  strict: false
})